<template>
  <div class="PlayersContainer">
  <div class="PlayersContainer__title">Whom do you want to watch?</div>
  <div class="PlayersContainer__close" @click="setPlayers(false)"></div>
  <div class="PlayersContainer__slider">
    <div class="Players">
      <div class="Players__item" v-for="item in playlist.players" @click="$emit('playVideo', item.url)">
        <div class="Players__item__picture" :style="{ backgroundImage: `url(${item.picture}` }"></div>
        <div class="Players__item__name">{{ item.name }}</div>
        <div class="Players__item__duration">({{ item.duration }})</div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import { mapState, mapMutations } from 'vuex';

  export default {
    mixins: [],
    components: {},
    data() {
      return {
      };
    },
    methods: {
      ...mapMutations(['setHighlights', 'initialHighLight', 'setPlayers']),
    },
    computed: {
      ...mapState(['highlights', 'playlist', 'players']),
    },
  };
</script>
<style lang="scss">
.PlayersContainer{
  position: relative;
  width: 100%;
  padding: 30px 0;
  @media (min-width: 768px) {
    padding: 30px;
    position: absolute;
    width: 80%;
    top: 80px;
    margin: 0 10%;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, .6);
  }
  &__slider {
    overflow: scroll;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
      height: 6px;
    }
    &::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #00acff;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3px;
    }
  }
  &__title {
    text-align: center;
    color: #00acff;
    margin-bottom: 20px;
  }
  &__close {
    cursor: pointer;
    position: absolute;
    top: 10px;
    left: 10px;
    background-image: url(../assets/img/ic_close.png);
    width: 20px;
    height: 20px;
    background-size: cover;
  }
}
.Players{
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  &__item{
    display: flex;
    flex-direction: column;
    cursor: pointer;
    &__picture{
      width: 100px;
      height: 100px;
      border-radius: 100px;
      margin: 0 20px;
      background-size: cover;
    }
    &__name{
      color: white;
      text-align: center;
      font-size: 13px;
      margin-top: 10px;
    }
    &__duration{
      color: white;
      text-align: center;
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Players.vue